import { PaymentHandler, PayResult } from '@/store/models';
import { getYandexPayment } from '@/store/api';
import scriptLoad from '@/commons/scriptLoad';
import { i18n } from '@/i18n';
import ui from '@/store/modules/ui';
import payment from '@/store/modules/payment';
import checkout from '@/store/modules/checkout';
import store from '@/store';

const sdkWidgetUrl = 'https://static.yoomoney.ru/checkout-client/checkout-widget.js';

export default class Yandex implements PaymentHandler {
    private params: any;
    private yandexClient: any;

    public init(params: any) {
        this.params = params;
        return new Promise((resolve, reject) => {
            const sdk = params.flow === 'tokenization' ? params.sdk_url : sdkWidgetUrl;
            scriptLoad(sdk, true).then(() => {
                switch (params.flow) {
                    case 'tokenization':
                        const yandexCheckout = YandexCheckout(params.shop_id);
                        resolve({
                            yandexClient: yandexCheckout,
                            flow: params.flow,
                        });
                        break;
                    case 'widget':
                        getYandexPayment('widgetWithReceipt').then((res) => {
                            let returnUrl = params.return_url + '?payment_id=' + res.id;
                            if (res.order_increment_id) {
                                returnUrl += '&order_id=' + res.order_increment_id;
                            }
                            const yandexCheckoutWidget = new window.YooMoneyCheckoutWidget({
                                confirmation_token: res.confirmation.confirmation_token,
                                return_url: returnUrl,
                                error_callback(error: any) {
                                    // Processing of initialization errors
                                },
                            });
                            this.yandexClient = yandexCheckoutWidget;
                            resolve({
                                yandexClient: yandexCheckoutWidget,
                                flow: params.flow,
                            });
                        });
                        break;
                }
            });
        });
    }

    public pay(amount: number): Promise<PayResult> {
        return new Promise((resolve, reject) => {
            const methodCode = checkout.selectedPaymentMethod.code;
            payment.unregisterMethod(methodCode).then(() => {
                ui.openModal('yandexpay');
                const formEl = document.getElementById('yandex-payment-form') as HTMLElement;
                formEl.innerHTML = ''; // reinit widget every time

                const yandexRegistrationReq = { methodCode, params: store.state.options.payment.yandexConfig };
                payment.registerMethod(yandexRegistrationReq).then((results) => {
                    this.yandexClient.render('yandex-payment-form');
                    resolve({needsFinalization: false});
                });
            });
        });
    }

    public teardown() {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }
}
